<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Manajemen Tryout</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Manajemen Tryout</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div>
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
							<div class="card">
								<div class="card-body pt-0" style="min-height:530px">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#tablatihan" data-toggle="tab">Latihan Soal</a>                                                
											</li> 

											<!-- <li class="nav-item">
												<a class="nav-link" href="#tabkategori" data-toggle="tab">Kategori</a>                                                
											</li> 
                                             
											<li class="nav-item">
												<a class="nav-link" href="#tabsubject" data-toggle="tab"><span class="med-records">Subject</span></a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
										
										<!-- Materi Tab -->
										<div id="tablatihan" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">

                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" data-toggle="modal" data-target="#addMdl" @click="resetVar()">Tambah Latihan</a>
                                                    </div>
													<div class="table-responsive">
                                                        <table id="tblLatihan" class="table table-hover table-center mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">#</th>
                                                                    <th class="text-left">Tingkatan / Kategori / Subject</th>
                                                                    <th class="text-left">Paket Soal</th>
                                                                    <th class="text-left">Jumlah Soal</th>
                                                                    <th class="text-left">Publish</th>
                                                                    <th class="text-left">Action</th>
                                                                </tr>
                                                            </thead>
                                        
                                                            <tbody>
                                                                <tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
                                                                    <td>{{ ref.nama_to }}</td>
                                                                    <td class="text-center">{{ ref.jumlah_soal }}</td>
                                                                    <td>
                                                                        <span v-if="ref.fg_publish">Aktif</span>
                                                                        <span v-if="!ref.fg_publish">Tidak Aktif</span>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getTryout(ref)">
                                                                            <i class="fas fa-eye"></i> Kerjakan
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-warning-light" depressed small @click="getHasilTryout(ref)">
                                                                            <i class="fas fa-eye"></i> Hasil
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-info-light" depressed small @click="getDetail(ref)">
                                                                            <i class="fas fa-eye"></i> Soal
                                                                        </v-btn>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>

                                                                        <v-btn v-if="ref.isnotdel=='0'" color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>                                            
                                                        </table>
                                                     
                                                    </div>
												</div>
											</div>
										</div>
                                        <!-- /Materi Tab -->
									
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>

                        
						
					</div>
				</div>

			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="hasilMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hasil pengerjaan Tryout {{tryout.nama_to}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table id="tblHasil" class="table table-hover table-center mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-left">#</th>
                                        <th class="text-left">Tanggal</th>
                                        <th class="text-left">Nilai</th>
                                        <th class="text-left">Waktu</th>
                                        <th class="text-left">Action</th>
                                    </tr>
                                </thead>
            
                                <tbody>
                                    <tr v-for="(ref, index) in lsthasil" :key="ref.id_user_to">
                                        <td>{{ index + 1 }}</td>
                                        <td>{{ ref.created_date }}</td>
                                        <td class="text-center">{{ ref.hasil }}</td>
                                        <td class="text-center">{{ ref.waktu }}</td>
                                        <td>
                                            <v-btn class="btn btn-sm bg-success-light" depressed small @click="getPembahasan(ref)">
                                                <i class="fas fa-eye"></i> Pembahasan
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>                                            
                            </table>
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div id="addMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Tambah Latihan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Nama Paket Latihan <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" v-model="tryout.nama_to" required>
                            </div>
                            <div class="form-group">
                                <label>Tingkatan</label>
                                <v-select
                                :options="lsttingkatan"
                                :reduce="lsttingkatan => lsttingkatan.id_tingkatan" 
                                label="nama_tingkatan"
                                v-model="tryout.id_tingkatan"
                                @input="filterKategori"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Kategori</label>
                                <v-select
                                :options="lstmateri"
                                :reduce="lstmateri => lstmateri.id_materi" 
                                label="optmateri"
                                v-model="tryout.id_materi"
                                @input="filterSubject"                                
                                />
                            </div>
                            <div class="form-group">
                                <label>Subject</label>
                                <v-select
                                :options="lstsubject"
                                :reduce="lstsubject => lstsubject.id_sub_materi" 
                                label="nama_sub_materi"
                                v-model="tryout.id_sub_materi"
                                />
                            </div>
                            <div class="form-group">
                                <label>Waktu Pengerjaan (dalam menit)<span class="text-danger">*</span></label>
                                <input class="form-control" type="number" v-model="tryout.waktu" required>
                            </div>
                            <div class="row">
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Mulai Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryout.start_date">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="form-group card-label">
                                        <label>Tanggal Akhir Event</label>
                                        <input class="form-control" type="datetime-local" v-model="tryout.end_date">
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="form-group">
                                <label>Tgl Mulai Event</label>
                                <v-select
                                :options="lststspublish"
                                :reduce="lststspublish => lststspublish.id" 
                                label="text"
                                v-model="tryout.fg_publish"
                                />                                
                            </div> -->
                        </form>
                    </div>
                    <div class="modal-footer">
                        <div class="submit-section">
                            <button class="btn btn-primary submit-btn" @click.prevent="save">Simpan</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Paket Latihan</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus latihan <b>{{ tryout.nama_to }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="kerjakanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hai, apakah kamu sudah siap mengerjakan Latihan ini?</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <br>
                        <table class="table">
                            <tr>
                                <td>Kategori</td>
                                <td>{{tryout.nama_materi}} / {{tryout.nama_sub_materi}}</td>
                            </tr>
                            <tr>
                                <td>Jumlah Soal</td>
                                <td>{{tryout.jumlah_soal}} Soal</td>
                            </tr>
                            <tr>
                                <td>Waktu Mengerjakan</td>
                                <td>{{tryout.waktu}} menit</td>
                            </tr>
                        </table>
                        <br>
                        <div role="alert" class="alert alert-warning">
                            <div class="col-auto">
                                <strong class="ml-0"><i class="fa fa-info-circle"></i> Perhatian!</strong><br>
                                <ol class="mb-0">
                                    <li>Gunakan browser Google Chrome versi terbaru supaya website dapat diakses dengan lancar tanpa masalah.</li>
                                    <li>Pastikan tidak ada aktivitas login ke akun anda (pada perangkat lain) saat sedang mengerjakan tryout.</li>                       
                                </ol>
                            </div>
						</div>
                    </div>

                    <div class="modal-footer">                        
                        <button class="btn btn-rounded btn-primary" @click.prevent="doTryout()"><i class="fa fa-user-edit"></i> Kerjakan Sekarang</button>
                        
                    </div>

                </div>
            </div>
        </div>
       
    </div>
</template>
<script>
import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'Materi',
    data() {
        return {
            lsttryout: [],
            lstsubject: [],
            lsthasil:[],
            tryout: {
                id_to: '',
                nama_to: '',
                id_tingkatan: '',
                id_materi: '',
                id_sub_materi: '',
                url: '',
                waktu: '',
                fg_publish: '',
                start_date: '',
                end_date: ''
            },
            lstmateri: [],
            lstsubmateri: [],
            lsttingkatan: [],
            lststspublish: [
                {id: '1', text: 'Aktif'},
                {id: '0', text: 'Tidak Aktif'}
            ]
        }
    },
    created: function () {
        this.getAll();
        this.getAllTingkatan();
        this.getAllMateri();
        this.getAllSubMateri();
    },  
    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },


        //--------------------------
        // Get Materi
        getAll: function () {
            axios.get('api/tryoutinst')
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tblLatihan");
                    this.lsttryout = res.data.data;
                    this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New Materi
        save: function () {
            axios.post('api/tryoutinst', {
                    created_by: localStorage.getItem('idUser'),
                    id_to: this.tryout.id_to,
                    nama_to: this.tryout.nama_to,
                    id_tingkatan: this.tryout.id_tingkatan,
                    id_materi: this.tryout.id_materi,
                    id_sub_materi: this.tryout.id_sub_materi,
                    waktu: this.tryout.waktu,
                    fg_publish: this.tryout.fg_publish,
                    start_date: this.tryout.start_date,
                    end_date: this.tryout.end_date
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        filterKategori: function(value){
            this.tryout.id_materi = '';
            this.lstmateri = value? this.lstmateriori.filter(c => c.id_tingkatan == value) : this.lstmateriori;
        },
        
        filterSubject: function(value){
            this.tryout.id_sub_materi = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },


        resetVar: function(ref,isDasabled=false){
            if(ref){                
                this.tryout.id_to = ref.id_to;
                this.tryout.nama_to = ref.nama_to;
                this.tryout.id_tingkatan = ref.id_tingkatan;
                this.tryout.id_materi = ref.id_materi;
                this.tryout.id_sub_materi = ref.id_sub_materi;
                this.tryout.waktu = ref.waktu;
                this.tryout.fg_publish = ref.fg_publish;
            } else {
                this.tryout.id_to = '';
                this.tryout.nama_to = '';
                this.tryout.id_tingkatan = '';
                this.tryout.id_materi = '';
                this.tryout.id_sub_materi = '';
                this.tryout.waktu = '';
                this.tryout.fg_publish = '';
            }
            
            $("#frm input").prop("disabled", isDasabled);
            $("#frm v-select").prop("disabled", isDasabled);
        },

        // Get Detail and Show data to Modal
        getDetail: function (ref) {
            // this.$router.push({name:'instructor-tryout-soal', params: {id: ref.id_to}}); 
            localStorage.removeItem('soal_id_soal');
            localStorage.setItem("soal_id_to", ref.id_to);      
            this.$router.push({name:'instructor-tryout-soal'});
        },

        // Get Detail and Show data to Modal
        getTryout: function (ref) {
            this.tryout = ref;
            $("#kerjakanMdl").modal('show');            
            // this.$router.push({name:'instructor-tryout-try', params: {id: ref.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        doTryout: function () {
            // this.tryout = ref;
            $("#kerjakanMdl").modal('hide');   
            localStorage.setItem("id_to", this.tryout.id_to);      
            localStorage.setItem("time", this.tryout.waktu*60);   
            const lstsoal = localStorage.getItem('lstsoal');
            if(lstsoal){
                localStorage.removeItem('lstsoal');
            }
            
            this.$router.push({name:'instructor-tryout-try'});//, params: {id: this.tryout.id_to}}); 
            // this.resetVar(ref, true);
            // $("#addMdl").modal('show');
        },

        getPembahasan: function (ref) {
            $("#hasilMdl").modal('hide');   
            localStorage.setItem("id_to", ref.id_to);      
            localStorage.setItem("id_user_to", ref.id_user_to);   
            
            this.$router.push({name:'instructor-tryout-pembahasan'});
        },
 
        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Materi
        hapus: function () {
            axios.post('api/tryoutinstdel', {
                    created_by: localStorage.getItem('idUser'),
                    id_to: this.tryout.id_to
                })
                .then(res => {
                    // handle success
                    this.resetVar();
                    this.getAll();
                    $("#delMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        //--------------------------
        // Get Tingkatan
        getAllTingkatan: function () {
            axios.get('api/reftingkatan')
                .then(res => {
                    // console.log(res.data);
                    this.lsttingkatan = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get Materi
        getAllMateri: function () {
            axios.get('api/materi')
                .then(res => {
                    // console.log(res.data);
                    this.lstmateri = res.data.data;
                    this.lstmateriori = res.data.data;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Get sub_materi
        getAllSubMateri: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getHasilTryout: function (ref) {
            axios.get('api/tryoutres/'+ref.id_to)
                .then(res => {
                    // console.log(res.data);
                    $("#hasilMdl").modal('show');
                    this.lsthasil = res.data.data;
                    this.initDt("tblHasil");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Instructor/Tryout/index.vue